import { IconSet } from '@postscript/components';
import {
  SMS_SALES_CONVERSATIONS,
  SMS_SALES_NAV,
} from 'components/admin/utils/feature-flags';
import { useMemo } from 'react';
import { NavMenuItem } from '../NavMenu';

export const useSmsSalesMenuItems = (): NavMenuItem[] => {
  return useMemo(
    () => [
      {
        id: 'sms-sales',
        label: 'SMS Sales',
        icon: IconSet.Dollar,
        isLoading: false,
        ariaLabelledBy: 'nav-sales-title',
        labsFeatureFlag: SMS_SALES_NAV,
        subMenu: [
          {
            link: '/sms-sales/performance',
            label: 'Performance',
            id: 'sms-sales-perforance',
          },
          {
            labsFeatureFlag: SMS_SALES_CONVERSATIONS,
            link: '/sms-sales/conversations',
            label: 'Conversations',
            id: 'sms-sales-conversations',
          },
          {
            link: '/sms-sales/conversation-intelligence?filters=HAS_SUMMARY',
            label: 'Conversation Intelligence',
            id: 'sms-sales-conversation-intelligence',
          },
        ],
      },
    ],
    [],
  );
};
